// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"ldEaT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HangmanPageElement", ()=>HangmanPageElement);
var _tsDecorate = require("@swc/helpers/_/_ts_decorate");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _cluster = require("../css/cluster");
var _form = require("../css/form");
var _reset = require("../css/reset");
var _stack = require("../css/stack");
var _type = require("../css/type");
var _decorators = require("../decorators");
var _freqsElement = require("../freqsElement");
var _letterFrequencies = require("../letterFrequencies");
var _util = require("../util");
var _wordList = require("../wordList");
var _wordListElement = require("../wordListElement");
function hangmanFilter(words, pattern, misses) {
    // The letters that have already been guessed (and are therefore not in
    // unknown parts of the solution) are determined by the known parts of
    // `pattern` and all of `misses`.
    const guessed = pattern.replace(/[^a-z]/g, "") + misses;
    // Regular expression character class to be used in place of the unknown
    // (hyphenated) parts of the pattern.
    const unguessedCharClass = `[^${guessed}]`;
    const patternRe = new RegExp(`^${pattern.replace(/[^a-z]/g, unguessedCharClass)}$`);
    return words.filter(patternRe.test.bind(patternRe));
}
const difference = (as, bs)=>as.filter((a)=>!bs.includes(a));
const strDifference = (strA, strB)=>difference(Array.from(strA), Array.from(strB)).join("");
// Make everything that's not a letter turn into a hyphen.
const normalizePattern = (pattern)=>pattern.toLowerCase().replace(/[^a-z]/g, "-");
// Only letters make sense --- remove anything else.
const normalizeMisses = (misses)=>misses.toLowerCase().replace(/[^a-z]/g, "");
class HangmanPageElement extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.pattern = "-u--le";
        this.misses = "aitb";
        this.words = [];
        this.freqs = {};
        this.limit = 1000 // don't render more than this many words at once
        ;
        this.rangeDescription = "" // "first 1000 of 2345"
        ;
        this.loading = true;
        this.error = false;
        this.freqs = (0, _letterFrequencies.wordsToFreqs)([]); // zero freqs
        this.updateResults();
    }
    updateResults() {
        this.loading = true;
        this.error = false;
        (0, _wordList.wordListPromise).then((wordList)=>{
            this.words = hangmanFilter(wordList, this.pattern, this.misses);
        }, (reason)=>{
            this.words = [];
            this.error = reason;
        }).finally(()=>{
            this.loading = false;
            this.rangeDescription = (0, _util.makeRangeDescription)(this.words.length, this.limit);
            this.freqs = (0, _letterFrequencies.wordsToFreqs)(this.words);
        });
    }
    onPatternChange(event) {
        let pattern = event.target.value;
        pattern = normalizePattern(pattern);
        // Prevent wrongly-guessed letters from becoming part of the solution.
        pattern = strDifference(pattern, this.misses);
        this.pattern = pattern;
        this.updateResults();
    }
    onMissesChange(event) {
        const target = event.target;
        let misses = target.value;
        misses = normalizeMisses(misses);
        // Prevent letters that are part of the solution from becoming part of
        // the wrongly-guessed letters.
        misses = strDifference(misses, this.pattern);
        // Remove duplicate misses; it only makes sense to guess a letter once.
        misses = (0, _util.uniq)(Array.from(misses)).join("");
        this.misses = misses;
        // A hack? to make sure the input's displayed value updates when the new
        // value undoes the change the user just made. Without this, the framework
        // sees "no change" and the user's change isn't undone.
        // https://github.com/Polymer/lit-element/issues/144#issuecomment-468098257
        target.value = this.misses;
        this.updateResults();
    }
    static get styles() {
        return [
            (0, _reset.resetCss),
            (0, _type.typeCss),
            (0, _form.formCss),
            (0, _stack.stackCss),
            (0, _cluster.clusterCss),
            (0, _lit.css)`
        mw-freqs {
            padding-right: 1rem;
            border-right: 1px solid black;
            margin-right: 1rem;
            float: left;
        }
      `
        ];
    }
    render() {
        return (0, _lit.html)`
      <div class="stack">
        <p>
          Type in your progress so far, indicating unsolved letters with a
          <samp>-</samp> (hyphen). Also enter the letters that have been guessed but
          aren't in the mystery word.
        </p>

        <div class="cluster">
          <div>
            <label for="pattern">Your progress</label>
            <input
                id="pattern"
                class="puzzle-input"
                autofocus
                spellcheck="false"
                .value="${this.pattern}"
                @input="${this.onPatternChange}">
          </div>

          <div>
            <label for="misses">Guessed letters</label>
            <input
                id="misses"
                class="puzzle-input"
                spellcheck="false"
                .value="${this.misses}"
                @input="${this.onMissesChange}">
          </div>
        </div>

        <div>
          <h2>See the ${this.pattern && this.rangeDescription} possible words</h2>

          ${this.loading ? (0, _lit.html)`<p>Loading&hellip;</p>` : null}

          ${this.error ? (0, _lit.html)`
          <p title="${JSON.stringify(this.error)}">
            Something&rsquo;s broken &mdash; we couldn't find your words.
          </p>
          ` : null}

          <mw-freqs .freqs="${this.freqs}"></mw-freqs>
          <mw-word-list .words="${this.words}" .limit="${this.limit}"></mw-word-list>
        </div>
      </div>
    `;
    }
}
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], HangmanPageElement.prototype, "pattern", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], HangmanPageElement.prototype, "misses", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], HangmanPageElement.prototype, "words", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], HangmanPageElement.prototype, "freqs", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], HangmanPageElement.prototype, "rangeDescription", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], HangmanPageElement.prototype, "loading", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], HangmanPageElement.prototype, "error", void 0);
(0, _tsDecorate._)([
    (0, _decorators.debounce)(350)
], HangmanPageElement.prototype, "updateResults", null);
HangmanPageElement = (0, _tsDecorate._)([
    (0, _decoratorsJs.customElement)("mw-hangman-page")
], HangmanPageElement);

},{"@swc/helpers/_/_ts_decorate":"3Z6vO","lit":"aCmte","lit/decorators.js":"kQrIl","../css/cluster":"bGJDG","../css/form":"8MMj0","../css/reset":"lBn3n","../css/stack":"812mT","../css/type":"9FxKK","../decorators":"d8Nql","../freqsElement":"dDwP2","../letterFrequencies":"kirYO","../util":"93Cnt","../wordList":"5Ye1N","../wordListElement":"4NDBJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGJDG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clusterCss", ()=>clusterCss);
var _lit = require("lit");
const clusterCss = (0, _lit.css)`
  .cluster {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-xs);
  }

  .cluster--space-between {
    justify-content: space-between;
  }

  .cluster--flex-end {
    justify-content: flex-end;
  }
`;

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d8Nql":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Prints the runtime for the method every time it's called. */ parcelHelpers.export(exports, "time", ()=>time);
/** Returns a decorator that debounces the method with the given wait time. */ parcelHelpers.export(exports, "debounce", ()=>debounce);
var _debounce = require("./debounce");
function time(target, propertyKey, descriptor) {
    const originalFunction = descriptor.value;
    descriptor.value = function() {
        console.time(originalFunction.name);
        const returnValue = originalFunction.apply(this, arguments);
        console.timeEnd(originalFunction.name);
        return returnValue;
    };
}
function debounce(waitTimeMs) {
    return function debounceDecorator(target, propertyKey, descriptor) {
        descriptor.value = (0, _debounce.debounce)(descriptor.value, waitTimeMs, true);
    };
}

},{"./debounce":"3kfkg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3kfkg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
function debounce(fn, waitMs, leading = false) {
    let timeoutId = null;
    function debounced(...args) {
        let fnThis = this;
        let fnArguments = arguments;
        if (timeoutId !== null) clearTimeout(timeoutId);
        if (leading && timeoutId === null) fn.apply(fnThis, fnArguments);
        timeoutId = window.setTimeout(()=>{
            fn.apply(fnThis, fnArguments);
            timeoutId = null;
        }, waitMs);
    }
    return debounced;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dDwP2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MyElement", ()=>MyElement);
var _tsDecorate = require("@swc/helpers/_/_ts_decorate");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _table = require("./css/table");
class MyElement extends (0, _lit.LitElement) {
    static get styles() {
        return [
            (0, _table.tableCss)
        ];
    }
    render() {
        const freqsArray = Object.entries(this.freqs).map(([letter, freq])=>({
                letter,
                freq
            }));
        // Sort descending by frequency
        freqsArray.sort((a, b)=>b.freq - a.freq);
        return (0, _lit.html)`
      <table>
        <thead>
          <tr>
            <td>Letter</td>
            <td>Words</td>
          </tr>
        </thead>
        <tbody>
          ${freqsArray.map((freq)=>(0, _lit.html)`
          <tr>
            <td>${freq.letter.toUpperCase()}</td>
            <td class="numerical">${freq.freq}</td>
          </tr>
          `)}
        </tbody>
      </table>
    `;
    }
    constructor(...args){
        super(...args);
        this.freqs = {};
    }
}
(0, _tsDecorate._)([
    (0, _decoratorsJs.property)()
], MyElement.prototype, "freqs", void 0);
MyElement = (0, _tsDecorate._)([
    (0, _decoratorsJs.customElement)("mw-freqs")
], MyElement);

},{"@swc/helpers/_/_ts_decorate":"3Z6vO","lit":"aCmte","lit/decorators.js":"kQrIl","./css/table":"e0NdS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e0NdS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tableCss", ()=>tableCss);
var _lit = require("lit");
const tableCss = (0, _lit.css)`
  .numerical {
    text-align: right;
  }
`;

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kirYO":[function(require,module,exports) {
// ASCII values of 'a' and 'z'.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return a frequency array object whose keys are letters of the alphabet and
 * whose values are the number of words that have the given letter.
 *
 * Implementation assumes words are in the ASCII character set and the number
 * of word is fewer than 2^32.
 */ parcelHelpers.export(exports, "wordsToFreqs", ()=>wordsToFreqs);
const aCharCode = "a".charCodeAt(0);
const zCharCode = "z".charCodeAt(0);
const numLetters = zCharCode - aCharCode;
// Letter frequencies are stored in an array of 26 slots --- one slot per
// letter of the alphabet.
const FreqsArray = Uint32Array;
// A letter frequency array with all zero frequencies. Used for initializing
// and resetting other frequency arrays.
const zero = new FreqsArray(numLetters);
// Conversions between ASCII character codes and indices used in letter
// frequency arrays
function charCodeToIdx(charCode) {
    return charCode - aCharCode;
}
function idxToCharCode(idx) {
    return idx + aCharCode;
}
/**
 * Convert a letter frequency array to a letter frequency object.
 *
 * For example, [5, 3, ..., 0] becomes {a: 5, b: 3, ..., z: 0}.
 */ function freqsArrayToFreqsObj(freqsArray) {
    const freqsObj = {};
    for(let i = 0; i < numLetters; i += 1)freqsObj[String.fromCharCode(idxToCharCode(i))] = freqsArray[i];
    return freqsObj;
}
function wordsToFreqs(words) {
    const freqs = new FreqsArray(zero);
    const freqsOfAWord = new FreqsArray(zero);
    let i;
    let j;
    for(i = 0; i < words.length; i += 1){
        const word = words[i];
        // Determine how this single word contributes to the letter frequencies for
        // all the words. Because we care about counting the number of words that
        // have a given letter, we only count the first occurrence of a letter in a
        // word and not repeated occurrences.
        freqsOfAWord.set(zero);
        for(j = 0; j < word.length; j += 1)freqsOfAWord[charCodeToIdx(word.charCodeAt(j))] = 1;
        // Add this word's contribution to the total frequencies.
        for(j = 0; j < numLetters; j += 1)freqs[j] += freqsOfAWord[j];
    }
    return freqsArrayToFreqsObj(freqs);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"93Cnt":[function(require,module,exports) {
// Return a noun-phrase for the first `limit`-many of `quantity`-many items.
// For example: "345", "first 100 of 345".
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeRangeDescription", ()=>makeRangeDescription);
// Given an array of values, return a subsequence where only the first
// occurrence of any given value is present.
parcelHelpers.export(exports, "uniq", ()=>uniq);
function makeRangeDescription(quantity, limit) {
    const desc = [];
    const truncated = quantity > limit;
    if (truncated) desc.push("first", limit, "of");
    desc.push(quantity);
    return desc.join(" ");
}
function uniq(as) {
    const set = new Set();
    return as.filter((a)=>{
        if (set.has(a)) return false;
        set.add(a);
        return true;
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["ldEaT"], "ldEaT", "parcelRequire85a9")

//# sourceMappingURL=index.9763c2bb.js.map
